import { axiosInstance } from "../axios/axiosConfig";

const controller = "StudentLearningProgresses";

export const upsertLearningProgress = async (data, userId, vodPublicId) => {
    try {
        const response = await axiosInstance.post(
            `${controller}?userId=${userId}&vodPublicId=${vodPublicId}`,
            data,
            {
                headers: {
                    'X-Skip-Loading': true
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const upsertReplayPlayingProgress = async (data, userId, coursePublicId, sessionId) => {
    try {
        const response = await axiosInstance.post(
            `${controller}/UpsertReplayPlayingProgress?userId=${userId}&coursePublicId=${coursePublicId}&sessionId=${sessionId}`,
            data,
            {
                headers: {
                    'X-Skip-Loading': true
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
